import { useForm, usePage } from "@inertiajs/react";
import { useEffect, useState } from "react";
import Navbar from "./Navbar";

export default function Header() {
    const { post, processing } = useForm();
    const { auth, momo_coin_balance: momoCoinBalance = 0 } = usePage().props;
    const [merchantCoinBalance, setMerchantCoinBalance] = useState(
        Number(momoCoinBalance) || 0
    );
    const [refreshingMerchantCoin, setRefreshingMerchantCoin] = useState(false);

    const formattedMomoBalance = new Intl.NumberFormat("id-ID").format(merchantCoinBalance);

    function signOut() {
        if (processing) return;

        post('/logout', {
            preserveScroll: true,
            onError: () => {
                window.location.href = '/login';
            },
        });
    }

    async function refreshMerchantCoinInfo() {
        if (refreshingMerchantCoin) return;

        try {
            setRefreshingMerchantCoin(true);
            const response = await window.axios.get("/panel/getmerchantcoinfinoo");
            const nextBalance = Number(
                response?.data?.data?.balance ??
                    response?.data?.data?.coin ??
                    0
            );

            setMerchantCoinBalance(Number.isFinite(nextBalance) ? nextBalance : 0);
        } catch (error) {
            const message =
                error?.response?.data?.message ??
                "Failed to refresh merchant coin info.";
            window.alert(message);
        } finally {
            setRefreshingMerchantCoin(false);
        }
    }

    useEffect(() => {
        refreshMerchantCoinInfo();
    },[])

    return (
        <>
            <header className="flex flex-col z-50">
                <nav className="bg-navbar border-b border-navbar-line">
                    <div className="max-w-[85rem] flex flex-row justify-between basis-full items-center w-full mx-auto py-2.5 px-4 sm:px-6 lg:px-8">
                        <div className="flex items-center gap-x-3">
                            <img className="size-10" src="/nitnot_emblem.png" alt="Nitnot" />
                            <h1 className="text-base sm:text-lg font-semibold text-foreground">
                                Nitnot Store Panel
                            </h1>
                        </div>

                        <div className="flex justify-end items-center gap-x-2 sm:gap-x-3">
                            <button
                                type="button"
                                onClick={refreshMerchantCoinInfo}
                                disabled={refreshingMerchantCoin}
                                className="inline-flex items-center gap-x-2 rounded-xl border border-navbar-divider bg-surface px-3 py-2 hover:bg-layer-hover disabled:opacity-60"
                            >
                                <span className="text-xs text-muted-foreground-1">Total Balance Momo Coin</span>
                                <span className="text-sm font-semibold text-foreground">
                                    {refreshingMerchantCoin ? "Refreshing..." : formattedMomoBalance}
                                </span>
                            </button>

                            <div className="hidden sm:block border-e border-navbar-divider w-px h-5" />

                            <div className="h-9.5">
                                <div className="hs-dropdown inline-flex [--strategy:absolute] [--auto-close:inside] [--placement:bottom-right] relative text-start">
                                    <button
                                        id="hs-dnad"
                                        type="button"
                                        className="inline-flex shrink-0 items-center gap-x-1.5 text-start rounded-full focus:outline-hidden"
                                        aria-haspopup="menu"
                                        aria-expanded="false"
                                        aria-label="Dropdown"
                                    >
                                        <img
                                            className="shrink-0 size-9.5 lg:size-8 rounded-full"
                                            src="https://images.unsplash.com/photo-1659482633369-9fe69af50bfb?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=3&w=320&h=320&q=80"
                                            alt="Avatar"
                                        />
                                    </button>

                                    <div className="hs-dropdown-menu hs-dropdown-open:opacity-100 w-60 transition-[opacity,margin] duration opacity-0 hidden z-20 bg-dropdown border border-dropdown-line rounded-xl shadow-xl" role="menu" aria-orientation="vertical" aria-labelledby="hs-dnad" tabIndex={-1}>
                                        <div className="p-1 border-b border-dropdown-divider">
                                            <div className="py-2 px-3 flex items-center gap-x-3 rounded-lg text-sm">
                                                <img
                                                    className="shrink-0 size-8 rounded-full"
                                                    src="https://images.unsplash.com/photo-1659482633369-9fe69af50bfb?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=3&w=320&h=320&q=80"
                                                    alt="Avatar"
                                                />
                                                <div className="grow">
                                                    <span className="text-sm font-semibold text-foreground">
                                                        {auth?.user?.name ?? 'User'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="p-1">
                                            <button
                                                type="button"
                                                onClick={signOut}
                                                disabled={processing}
                                                className="flex w-full items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-dropdown-item-focus"
                                            >
                                                Sign out
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="lg:hidden">
                                <button
                                    type="button"
                                    className="hs-collapse-toggle size-9.5 flex justify-center items-center text-sm font-semibold rounded-xl bg-layer border border-layer-line text-layer-foreground hover:bg-layer-hover focus:outline-hidden focus:bg-layer-focus disabled:opacity-50 disabled:pointer-events-none"
                                    id="hs-pro-emh-collapse"
                                    aria-expanded="false"
                                    aria-controls="hs-pro-emh"
                                    aria-label="Toggle navigation"
                                    data-hs-collapse="#hs-pro-emh"
                                >
                                    <svg className="hs-collapse-open:hidden shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="3" x2="21" y1="6" y2="6"></line>
                                        <line x1="3" x2="21" y1="12" y2="12"></line>
                                        <line x1="3" x2="21" y1="18" y2="18"></line>
                                    </svg>
                                    <svg className="hs-collapse-open:block hidden shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M18 6 6 18"></path>
                                        <path d="m6 6 12 12"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </nav>

                <Navbar />
            </header>
        </>
    );
}
